import {Injectable, OnInit} from '@angular/core';
import 'rxjs/add/operator/map';

@Injectable()
export class ConstantProvider implements OnInit {

  public API_URL: string;
  public API_URL_JAVA: string;
  public listTipoCliente: any = [{'optKey': 'F', 'optVal': 'PF'}, {'optKey': 'J', 'optVal': 'PJ'}];
  public listTipoMercado: any = [{'optKey': 'I', 'optVal': 'INTERNO'}, {'optKey': 'E', 'optVal': 'EXTERNO'}];
  public listSimNaoSN: any = [{'optKey': 'S', 'optVal': 'SIM'}, {'optKey': 'N', 'optVal': 'NÃO'}];

  public listTipoFrete: any = [{'optKey': 'T', 'optVal': 'POR TONELADA'}, {'optKey': 'V', 'optVal': 'POR VIAGEM'}];

  public listFormaPagto: any = [{'optKey': 'DEP', 'optVal': 'DEPÓSITO'}, {'optKey': 'BOL', 'optVal': 'BOLETOS'}, {'optKey': 'OUT', 'optVal': 'OUTROS'}];

  public listOrigem: any = [
    // {'optKey': 'B', 'optVal': 'BLOCO'},
    {'optKey': 'I', 'optVal': 'IMPORTADO'},
    // {'optKey': 'O', 'optVal': 'INSUMO'},
    {'optKey': 'N', 'optVal': 'NACIONAL'},
    // {'optKey': 'S', 'optVal': 'SERVIÇO'},
    {'optKey': 'T', 'optVal': 'MATERIAL DE TERCEIRO'}
    ];

  public listSitPedido: any = [
    {'optKey': '1', 'optVal': 'ABERTO TOTAL'},
    {'optKey': '2', 'optVal': 'ABERTO PARCIAL'},
    {'optKey': '3', 'optVal': 'SUSPENSO'},
    {'optKey': '4', 'optVal': 'LIQUIDADO'},
    {'optKey': '5', 'optVal': 'CANCELADO'},
    {'optKey': '9', 'optVal': 'NÃO FECHADO'}
    ];

  private SAPIENS_CODEMP: string;
  private SAPIENS_CODFIL: string;

  ngOnInit() {
  }

  constructor() {
    this.API_URL = "https://api3.cajugram.com/api";
    if (document.URL.indexOf("localhost") > 0 || document.URL.indexOf("app-dev") > 0) {
      this.API_URL = "https://api-dev.cajugram.com.br/api";
    } else if (document.URL.indexOf("leandromelo") > 0) {
      this.API_URL = "https://api-dev2.cajugram.com.br/api";
    }
  }

  SetConstant(consField, value) {
    eval('this.' + consField + ' = ' + value + ';');
  }

  GetConstant(consField) {
    return eval('this.' + consField);
  }

}



// WEBPACK FOOTER //
// ./src/providers/constants.ts